var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box",attrs:{"lang":"vi"}},[_c('h3',[_vm._v("Thỏa thuận người dùng V720 Pro")]),_c('div',{staticClass:"vhtml",domProps:{"innerHTML":_vm._s(_vm.htmlText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }